import React from 'react';
import styles from './Projects.module.scss';

import projects from '../../constants/projects';
import Project from '../Project/Project';

function Projects() {
  return (
    <section className={styles.section}>
      <div className={styles.projects_grid_container}>
        <Project
          href={projects.one.href}
          image={projects.one.image}
          desc="Aroma is a fictional cafe website. It makes use of React, React-router, JOI data validation, MUI components, Unsplash API and react-testing-library."
        />
        <Project
          href={projects.two.href}
          image={projects.two.image}
          desc="Toretto's Luxury Car Tuning is built from scratch. Designed to show a seamless design with a mobile first approach. Built using React, Redux and Sass"
        />
        <Project
          href={projects.three.href}
          image={projects.three.image}
          desc="This is Moogle Tasks. Designed to emulate basic functionality of a basic google application. Built using html, css and vanilla javascript."
        />
        <Project
          href={projects.four.href}
          image={projects.four.image}
          desc="YouTelly makes use of the YouTube api, react controlled components and semantic ui library to deliver a simple YouTube experience."
        />
      </div>
    </section>
  );
}

export default Projects;
